import { IOfferHouse } from '../../../types/offer';

interface IGetOfferSubtitle {
  isNewbuilding: boolean;
  originalSubtitle?: string;
  house?: IOfferHouse | null;
}

export function getOfferSubtitle({ isNewbuilding, originalSubtitle, house }: IGetOfferSubtitle) {
  const { section, finishDate, isFinished } = house || {};

  if (!isNewbuilding || !house) {
    return originalSubtitle;
  }

  const parts = [];

  if (section) {
    parts.push(section);
  }

  if (isFinished) {
    parts.push('Сдан');
  } else if (!isFinished && finishDate) {
    parts.push(`Сдача корпуса ${finishDate.quarter} кв. ${finishDate.year}`);
  }

  return parts.join(' • ');
}
